import React from "react";
import { Avatar, Typography } from "antd/lib";
import Image from "next/image";
import { CheckOutlined } from "@ant-design/icons";
import classNames from "classnames";
import bitcoinIcon from "@/asset/images/chains/bitcoin.svg";
import usdtIcon from "@/asset/images/usdt.svg";
import { formatThousands } from "@/helpers";
import { PercentChange } from "@/app/components/percentChange";
import { useCurrencyContext } from "@/context/CurrencyContext";
import type { IProductMarket } from "../Market";

interface MarketItemProps {
  item: IProductMarket;
}

const MarketItem: React.FC<MarketItemProps> = ({ item }) => {
  const { currentCurrency } = useCurrencyContext();

  return (
    <div
      key={item._id}
      className={classNames("p-6 rounded-lg", {
        "bg-[#F6FFED]": item.changePercent > 0,
        "bg-[#FFF1F0]": item.changePercent <= 0,
      })}
    >
      <div className="flex flex-col gap-3">
        <div className="flex justify-between items-center">
          <div className="flex gap-2 items-center">
            <Avatar src={item.exchangeIcon} size={32} alt={item.symbol} />
            <Typography.Text strong>{item.exchangeName}</Typography.Text>
          </div>
        </div>
        <div className="flex justify-between items-center">
          <div className="flex gap-2">
            <Avatar.Group>
              <Image src={bitcoinIcon} className="w-6 h-6" alt={item.symbol} priority />
              <Image src={usdtIcon} className="w-6 h-6" alt={item.symbol} priority />
            </Avatar.Group>
            <Typography.Text>{item.symbol}</Typography.Text>
          </div>
          <div className="flex gap-2">
            <Typography.Text strong>{formatThousands(item.close, currentCurrency)}</Typography.Text>
            <PercentChange change={(item.changePercent as number) / 100} />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          {item.description?.map((desc, index) => (
            <div key={desc + index} className="flex gap-2">
              <CheckOutlined style={{ color: "#1A56DB" }} />
              <Typography.Text type="secondary">{desc}</Typography.Text>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MarketItem;
